import Comment from '../api/comment';
import { applicationSave, applicationFetchAll, applicationUpdate, applicationDestroy } from './applicationActions';

export const saveComment = applicationSave(Comment);
export const fetchComments = applicationFetchAll(Comment);
export const updateComment = applicationUpdate(Comment);
export const destroyComment = applicationDestroy(Comment);
